import { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { KeyRound } from "lucide-react";

export default function ChangePasswordDialog({ open, onOpenChange }) {
  const [form, setForm] = useState({ old_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const submit = async () => {
    if (form.new_password.length < 6) { toast.error("Neues Passwort: mind. 6 Zeichen"); return; }
    if (form.new_password !== form.confirm) { toast.error("Passwörter stimmen nicht überein"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { old_password: form.old_password, new_password: form.new_password });
      toast.success("Passwort geändert");
      setForm({ old_password: "", new_password: "", confirm: "" });
      onOpenChange(false);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Fehlgeschlagen");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0C0E12] border-zinc-800 rounded-sm">
        <DialogHeader>
          <DialogTitle className="font-heading text-zinc-100 flex items-center gap-2">
            <KeyRound className="h-4 w-4 text-primary" /> Passwort ändern
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 pt-2">
          <div className="space-y-1.5">
            <Label className="text-[11px] font-bold uppercase tracking-[0.12em] text-zinc-500">Aktuelles Passwort</Label>
            <Input data-testid="cp-old" type="password" value={form.old_password} onChange={(e) => set("old_password", e.target.value)} className="bg-transparent border-zinc-700 rounded-sm focus-visible:ring-primary" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-[11px] font-bold uppercase tracking-[0.12em] text-zinc-500">Neues Passwort</Label>
            <Input data-testid="cp-new" type="password" value={form.new_password} onChange={(e) => set("new_password", e.target.value)} className="bg-transparent border-zinc-700 rounded-sm focus-visible:ring-primary" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-[11px] font-bold uppercase tracking-[0.12em] text-zinc-500">Neues Passwort bestätigen</Label>
            <Input data-testid="cp-confirm" type="password" value={form.confirm} onChange={(e) => set("confirm", e.target.value)} className="bg-transparent border-zinc-700 rounded-sm focus-visible:ring-primary" />
          </div>
          <Button data-testid="cp-submit" onClick={submit} disabled={busy} className="w-full rounded-sm bg-primary hover:bg-blue-600 text-white">
            {busy ? "Speichern…" : "Passwort ändern"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
